import IconMessageList from './icon-message-list';

export default IconMessageList;
